import { render } from "./chat_new.vue?vue&type=template&id=527ae593"
import script from "./chat_new.js?vue&type=script&lang=js"
export * from "./chat_new.js?vue&type=script&lang=js"

import "./chat_new.vue?vue&type=style&index=0&id=527ae593&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__